var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "alarm-flash-fade" } }, [
    _vm.visible
      ? _c("div", { staticClass: "alarm-flash" }, [
          _c(
            "div",
            { staticClass: "alarm-flash__banner", on: { click: _vm.dismiss } },
            [
              _c("v-icon", { staticClass: "alarm-flash__icon" }, [
                _vm._v("mdi-bell-ring")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "alarm-flash__text" }, [
                _c("span", { staticClass: "alarm-flash__title" }, [
                  _vm._v(_vm._s(_vm.$t("alarm.new_alarm_flash")))
                ]),
                _vm._v(" "),
                _vm.alarmName
                  ? _c("span", { staticClass: "alarm-flash__alarm" }, [
                      _vm._v(_vm._s(_vm.alarmName))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.locationLabel
                  ? _c("span", { staticClass: "alarm-flash__subtitle" }, [
                      _vm._v(_vm._s(_vm.locationLabel))
                    ])
                  : _vm._e()
              ])
            ],
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dc91315a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc91315a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Alarm/AlarmFlashOverlay.vue
// module id = null
// module chunks = 